import './tw.css'

import Login from './containers/Login'
import HomePage from './containers/HomePage'
import PrivateRoute from './utils/PrivateRoute'
import DynamicModal from './components/utility/DynamicModal'
import BiltyTrackingTable from './components/tables/BiltyTrackingTable'
import UserManagementTable from './components/tables/UserManagementTable'
import BiltyManagementTable from './components/tables/BiltyManagementTable'
import TrackerManagementTable from './components/tables/TrackerManagementTable'

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import JobSideDrawer from './components/drawers/JobSideDrawer'

const App = () => {
	return (
		<Router>
			<Routes>
				<Route
					element={
						<PrivateRoute redirect='../auth/login'>
							<HomePage />
						</PrivateRoute>
					}
				>
					<Route path='biltyManagement/:orderType/:tabStatus?' element={<BiltyManagementTable />}>
						<Route path='orders/:id?' element={<DynamicModal />}>
							<Route path=':modalType' />
						</Route>
						<Route path='job/:id'>
							<Route path='sideDrawer' element={<JobSideDrawer />}>
								<Route path=':modalType/:selectedBiltyNumber?' element={<DynamicModal />} />
							</Route>
							<Route path=':modalType' element={<DynamicModal />} />
						</Route>
					</Route>
					<Route path='biltyTracking/:tabStatus?' element={<BiltyTrackingTable />}>
						<Route path='job/:id'>
							<Route path='sideDrawer' element={<JobSideDrawer />}>
								<Route path=':modalType' element={<DynamicModal />} />
							</Route>
							<Route path=':modalType' element={<DynamicModal />} />
						</Route>
					</Route>
					<Route path='userManagement' element={<UserManagementTable />}>
						<Route path='user/:id/:modalType' element={<DynamicModal />} />
					</Route>
					<Route path='trackerManagement' element={<TrackerManagementTable />}>
						<Route path=':modalType' element={<DynamicModal />} />
					</Route>
				</Route>
				<Route path='auth/:action' element={<Login />} />
				<Route path='*' element={<Navigate to='biltyManagement/Import' replace />} />
			</Routes>
		</Router>
	)
}

export default App
